import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from '../index.module.css'; // Replace with actual CSS module

const SkeletonLotteryResultCard = () => {
  return (
    <div className={styles.lotteryBoxCard}>
      <div className={styles.detailscard}>
        <div className={styles.ticketDetails}>
          {/* Image or logo skeleton */}
          <div className={styles.logoSkeleton}>
            <Skeleton height={80} width={120} />
          </div>

          {/* Title */}
          {/* <p className={styles.pricetitle}><Skeleton width={120} /></p> */}

          {/* Prize */}
          <p className={styles.prize}><Skeleton width={180} height={30} /></p>

          {/* Brand Name */}
          <p className={styles.brandName}><Skeleton width={140} /></p>

          {/* Draw info */}
          {/* <div className={styles.detailsRow}>
            <p className={styles.rowText}><Skeleton width={80} /></p>
            <p className={styles.rowText}><Skeleton width={100} /></p>
          </div> */}

          {/* Number balls */}
          <div className={styles.numberBallRow}>
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className={styles.ballSkeleton}>
                <Skeleton circle={true} height={40} width={40} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLotteryResultCard;